import './styles/main.css';
import { mountAll } from './lib/components/calculatorForm';
import { mountThemeToggle } from './lib/components/theme';
import { DEFAULT_LOCALE, LOCALES, type LocaleCode } from './lib/i18n/index';

/**
 * Single entry point for every page.
 *
 * Pages are static HTML generated at build time; this only adds the interactive layer. A
 * page with no calculators on it loads the stylesheet and does nothing else.
 */
function currentLocale(): LocaleCode {
  const lang = document.documentElement.lang;
  return LOCALES.find((l) => l.htmlLang === lang)?.code ?? DEFAULT_LOCALE;
}

// The theme is already painted by the inline script in the template; this only makes the
// button work, so it is safe to run after first paint alongside everything else.
mountThemeToggle();

mountAll(currentLocale());
